import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={5}
      y={3}
      width={14}
      height={18}
      rx={2}
      stroke="#111111"
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;